/** Ответ монолита валиден, если есть auth_tokens и числовой server_timestamp. */
export function isValidAuthTokensResponse(data) {
  if (!data || typeof data !== 'object') {
    return false;
  }

  return (
    Boolean(data.auth_tokens) &&
    typeof data.server_timestamp === 'number'
  );
}

export function getServerTimestampFromPayload(data) {
  if (!data || typeof data !== 'object') {
    return null;
  }

  return typeof data.server_timestamp === 'number' ? data.server_timestamp : null;
}
